<!--
 * @Author: xing.huang
 * @Date: 2021-01-28 11:27:23
 * @LastEditTime: 2021-03-03 11:22:36
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\FactoryModel\AddStockDialog.vue
 * @
-->
<template>
	<div id="importOrderDialog">
		<el-dialog  title="批量新增库位"  :visible.sync="isShowDialog" :width="W?'60%':'70%'" center :close-on-click-modal="false" @close="cancelAddDialog">
            <el-form :model="addForm" :rules="rules" ref="addForm" style="width:100%;" class="add_form">
                <el-row :gutter="20" style="margin-bottom:0px">
                    <el-col :span="12">
                        <span class="title">库区编码：</span>
                        <el-form-item prop="areaCode" class="value" :rules="rules.areaCode" style="display: inline-block;max-width:180px">
                            <el-input size="small"   v-model="addForm.areaCode" maxlength="50" placeholder="库区编码" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">货列号：</span>
                        <el-form-item class="value"  style="display: inline-block;max-width:100px">
                            <el-select      v-model="addForm.numberType"   placeholder="数字类型" remote>
                                <el-option  :key="0" label="连续" :value="0"></el-option>
                                <el-option  :key="1" label="奇数" :value="1"></el-option>
                                <el-option  :key="2" label="偶数" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="cargoColumnNumberStart" class="value" :rules="rules.cargoColumnNumberStart" style="display: inline-block;max-width:120px">
                            <el-input size="small"   v-model="addForm.cargoColumnNumberStart" maxlength="50" placeholder="起始数" ></el-input>
                        </el-form-item>
                        <span>至</span>
                        <el-form-item prop="cargoColumnNumberEnd" class="value" :rules="rules.cargoColumnNumberEnd" style="display: inline-block;max-width:120px">
                            <el-input size="small"   v-model="addForm.cargoColumnNumberEnd" maxlength="50" placeholder="结束数" ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-bottom:0px">
                    <el-col :span="12">
                        <span class="title">列：</span>
                        <el-form-item class="value"  style="display: inline-block;max-width:100px">
                            <el-select      v-model="addForm.numberType1"   placeholder="数字类型" remote>
                                <el-option  :key="0" label="连续" :value="0"></el-option>
                                <el-option  :key="1" label="奇数" :value="1"></el-option>
                                <el-option  :key="2" label="偶数" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="positionColumnStart" class="value" :rules="rules.positionColumnStart" style="display: inline-block;max-width:120px">
                            <el-input size="small"   v-model="addForm.positionColumnStart" maxlength="50" placeholder="起始数" ></el-input>
                        </el-form-item>
                        <span>至</span>
                        <el-form-item prop="positionColumnEnd" class="value" :rules="rules.positionColumnEnd" style="display: inline-block;max-width:120px">
                            <el-input size="small"   v-model="addForm.positionColumnEnd" maxlength="50" placeholder="结束数" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">层：</span>
                        <el-form-item class="value"  style="display: inline-block;max-width:100px">
                            <el-select      v-model="addForm.numberType2"   placeholder="数字类型" remote>
                                <el-option  :key="0" label="连续" :value="0"></el-option>
                                <el-option  :key="1" label="奇数" :value="1"></el-option>
                                <el-option  :key="2" label="偶数" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="positionLayerStart" class="value" :rules="rules.positionLayerStart" style="display: inline-block;max-width:120px">
                            <el-input size="small"   v-model="addForm.positionLayerStart" maxlength="50" placeholder="起始数" ></el-input>
                        </el-form-item>
                        <span>至</span>
                        <el-form-item prop="positionLayerEnd" class="value" :rules="rules.positionLayerEnd" style="display: inline-block;max-width:120px">
                            <el-input size="small"   v-model="addForm.positionLayerEnd" maxlength="50" placeholder="结束数" ></el-input>
                        </el-form-item>
                    </el-col> 
                </el-row>
                <el-button type="primary" size="mini" style="margin-bottom:10px"   @click="createStock">预览</el-button>
                    <div>
                        <div v-for="(item,index) in list" :key="index" >
                            <div v-if="item" class="column-warp">
                                <div  v-for="(sub,subIndex) in item" :key="subIndex" class="column">
                                    <div v-for="(lastItem,lastIndex) in sub" :key="lastIndex" class="item">
                                        <span >{{lastItem.positionName}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </el-form>

			<div style="text-align: center;">
                <el-button type="primary" @click="submitAddStock">确 定</el-button>
                <el-button  @click="cancelAddDialog">取 消</el-button>
            </div>

		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'AddStockDialog',
	props: {
        showBatchStock: Boolean,
        id:Number,
	},
	data() {
        let that = this
		return {
            
            W:true,
            isShowDialog: false,
            addForm:{
                areaCode:'',
                cargoColumnNumberStart:'',
                cargoColumnNumberEnd:'',
                positionLayerStart:'',
                positionLayerEnd:'',
                positionColumnStart:'',
                positionColumnEnd:'',
                numberType:0,
                numberType1:0,
                numberType2:0,
            },
            submitList:[],
            cargoColumnNumberList:[],
            positionLayerList:[],
            positionColumnList:[],
            list:[],
            rules:{
                areaCode: [
                    {required: true, message: '请输入库区编码', trigger: 'blur'}
                ],
                cargoColumnNumberStart: [
                    {
                        validator(rule, value, callback) {
                            log(value,1000)
                            if(!value&&value!=='0'){
                                callback(new Error('开始数字不能为空'))
                            }else{
                                log(value,1234)
                                value = Number(value)
                                log(value,isNaN(value),that.addForm,888)
                                if (isNaN(value)) {
                                    callback(`开始数字必须为数字`)
                                } else {
                                    if(Number.isInteger(value)&&value>=0){
                                        callback()
                                    }else{
                                        callback(new Error('开始数字必须为非负整数'))
                                    }
                                }
                            }
                            
                        }, trigger: 'blur'
                    }
                ],
                cargoColumnNumberEnd: [
                    {
                        validator(rule, value, callback) {
                            if(!value&&value!=='0'){
                                callback(new Error('结束数字不能为空'))
                            }else{
                                value = Number(value)
                                if (isNaN(value)) {
                                    callback(`结束数字必须为数字`)
                                } else {
                                    if(Number.isInteger(value)&&value>=0){
                                        if(value<that.addForm.cargoColumnNumberStart){
                                            callback(new Error('结束数字不能小于开始数字'))
                                        }else{
                                            callback()
                                        }
                                        
                                    }else{
                                        callback(new Error('结束数字必须为非负整数'))
                                    }
                                }
                            }
                            
                        }, trigger: 'blur'
                    }
                ],
                positionColumnStart: [
                    {
                        validator(rule, value, callback) {
                            if(!value&&value!=='0'){
                                callback(new Error('开始数字不能为空'))
                            }else{
                                value = Number(value)
                                if (isNaN(value)) {
                                    callback(`开始数字必须为数字`)
                                } else {
                                    if(Number.isInteger(value)&&value>=0){
                                        callback()
                                    }else{
                                        callback(new Error('开始数字必须为非负整数'))
                                    }
                                }
                            }
                            
                        }, trigger: 'blur'
                    }
                ],
                positionColumnEnd: [
                    {
                        validator(rule, value, callback) {
                            if(!value&&value!=='0'){
                                callback(new Error('结束数字不能为空'))
                            }else{
                                value = Number(value)
                                if (isNaN(value)) {
                                    callback(`结束数字必须为数字`)
                                } else {
                                    if(Number.isInteger(value)&&value>=0){
                                        if(value<that.addForm.positionColumnStart){
                                            callback(new Error('结束数字不能小于开始数字'))
                                        }else{
                                            callback()
                                        }
                                        
                                    }else{
                                        callback(new Error('结束数字必须为非负整数'))
                                    }
                                }
                            }
                            
                        }, trigger: 'blur'
                    }
                ],
                positionLayerStart: [
                    {
                        validator(rule, value, callback) {
                            if(!value&&value!=='0'){
                                callback(new Error('开始数字不能为空'))
                            }else{
                                value = Number(value)
                                if (isNaN(value)) {
                                    callback(`开始数字必须为数字`)
                                } else {
                                    if(Number.isInteger(value)&&value>=0){
                                        callback()
                                    }else{
                                        callback(new Error('开始数字必须为非负整数'))
                                    }
                                }
                            }
                            
                        }, trigger: 'blur'
                    }
                ],
                positionLayerEnd: [
                    {
                        validator(rule, value, callback) {
                            if(!value&&value!=='0'){
                                callback(new Error('结束数字不能为空'))
                            }else{
                                value = Number(value)
                                if (isNaN(value)) {
                                    callback(`结束数字必须为数字`)
                                } else {
                                    if(Number.isInteger(value)&&value>=0){
                                        if(value<that.addForm.positionLayerStart){
                                            callback(new Error('结束数字不能小于开始数字'))
                                        }else{
                                            callback()
                                        }
                                        
                                    }else{
                                        callback(new Error('结束数字必须为非负整数'))
                                    }
                                }
                            }
                            
                        }, trigger: 'blur'
                    }
                ],
            }
        }
    },
    mounted(){
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        this.W = w>=1900?true:false
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            this.W = w>=1900?true:false
        }
    },
    methods:{
        submitAddStock(){
             this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    if(this.submitList.length==0){
                        this.createStock()
                    }
                    this.$RequestUtil.post({
                        url: '/api/factoryModel/batchAddFactoryModelPosition',
                        type:'sync',
                        params:{
                            factoryModelPositionList:this.submitList,
                            id:this.id
                        },
                        success: async (res) => {
                            if(res.code ==0){
                                this.$message.success('新增成功')
                                
                                this.cancelAddDialog()
                                await this.$parent.loadOrganizationData(this.id) 
                                
                            }else{
                                this.$message.error(res.msg || res.message);
                            }
                        }
                    })
                }
             })
        },
        cancelAddDialog(){
            this.addForm = {
                areaCode:'',
                cargoColumnNumberStart:'',
                cargoColumnNumberEnd:'',
                positionLayerStart:'',
                positionLayerEnd:'',
                positionColumnStart:'',
                positionColumnEnd:'',
                numberType:0,
                numberType1:0,
                numberType2:0,
            }
            this.list = []
            this.submitList = []
            this.$parent.showBatchStock = false
        },
        getNumbersList(start,end,type){
            //type 0 - 连续数 1-奇数 2-偶数
            let list = []
            start=Number(start)
            end = Number(end)
            for(let i = start;i<=end;i++){
                
                if(type==0){
                    list.push(i)
                }else if(type==1){
                    if(i%2==1){
                        list.push(i)
                    }
                }else{
                    if(i%2==0){
                        list.push(i)
                    }
                }
            }
            return list
        },
        createStock(){
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    let list = []
                    let submitList = []
                    let cargoColumnNumberList = this.getNumbersList(this.addForm.cargoColumnNumberStart,this.addForm.cargoColumnNumberEnd,this.addForm.numberType)
                    let positionLayerList = this.getNumbersList(this.addForm.positionLayerStart,this.addForm.positionLayerEnd,this.addForm.numberType2)
                    let positionColumnList = this.getNumbersList(this.addForm.positionColumnStart,this.addForm.positionColumnEnd,this.addForm.numberType1)
                    // 货列限制20了 层数限制5  列限制10
                    if(cargoColumnNumberList.length==0){
                        let typeStr = '奇数'
                        if(this.addForm.numberType==2){
                            typeStr = '偶数'
                        }
                        this.$message.warning(`货列号${this.addForm.cargoColumnNumberStart}——${this.addForm.cargoColumnNumberEnd}连续${typeStr}不存在`)
                        return
                    }else{
                        if(cargoColumnNumberList.length>20){
                            this.$message.warning(`货列号长度不能超过20`)
                            return
                        }
                    }

                    if(positionLayerList.length==0){
                        let typeStr = '奇数'
                        if(this.addForm.numberType2==2){
                            typeStr = '偶数'
                        }
                        this.$message.warning(`层${this.addForm.positionLayerStart}——${this.addForm.positionLayerEnd}连续${typeStr}不存在`)
                        return
                    }else{
                        if(positionLayerList.length>5){
                            this.$message.warning(`层长度不能超过5`)
                            return
                        }
                    }
                    if(positionColumnList.length==0){
                        let typeStr = '奇数'
                        if(this.addForm.numberType1==2){
                            typeStr = '偶数'
                        }
                        this.$message.warning(`货${this.addForm.positionColumnStart}——${this.addForm.positionColumnEnd}连续${typeStr}不存在`)
                        return
                    }else{
                        if(positionColumnList.length>10){
                            this.$message.warning(`列长度不能超过10`)
                            return
                        }
                    }
                    positionLayerList.sort((n1,n2)=>n2-n1)
                    cargoColumnNumberList.forEach(a=>{  //货列号
                        let list0 = []
                        positionLayerList.forEach(l=>{  //层
                            let list1 = []
                            positionColumnList.forEach(c=>{  //列
                                let json={
                                    positionName:this.addForm.areaCode+'-'+a+'-'+c+'-'+l,
                                    areaCode:this.addForm.areaCode,
                                    cargoColumnNumber:a,
                                    positionColumn:c,
                                    positionLayer:l
                                }
                                list1.push(json)
                                submitList.push(json)
                            })
                            list0.push(list1)
                        })
                        list.push(list0)
                    })
                    this.positionLayerList = positionLayerList
                    this.positionColumnList = positionColumnList
                    this.cargoColumnNumberList = cargoColumnNumberList
                    this.list = list
                    this.submitList = submitList
                    log(list,123456)
                }
            })
        },
    },
    watch: {
		"showBatchStock": function (newVal, oldVal) {
			this.isShowDialog = this.showBatchStock;
		},
	},
}
</script>
<style scoped>
.column-warp{
    border-bottom: 1px solid #ccc;
    margin-bottom: 20px;
}
.column{
    display: flex;
    
    border-right: 1px solid #ccc;
}
.column .item{
    flex: 1;
    height: 40px;
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    text-align: center;
    line-height: 40px;
    
}
.title {
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
    display: inline-block;
    text-align: right;
    width: 70px;
}

.value {
    display: inline-block
}
</style>



// WEBPACK FOOTER //
// src/views/FactoryModel/AddStockDialog.vue